import { render, staticRenderFns } from "./ClientsStatistic.vue?vue&type=template&id=fddb1ce0&scoped=true"
import script from "./ClientsStatistic.vue?vue&type=script&lang=js"
export * from "./ClientsStatistic.vue?vue&type=script&lang=js"
import style0 from "./ClientsStatistic.vue?vue&type=style&index=0&id=fddb1ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddb1ce0",
  null
  
)

export default component.exports